<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>HEGEMONY <span class="small">OR</span> SURVIVAL</strong><br/>AMERICA’S QUEST FOR GLOBAL DOMINANCE</h1>
<p class="publisher"><strong>A Holt Paperback<br/>Metropolitan Books / Henry Holt and Company | New York</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?336800c8